// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_POST = "pridanie diskusie";
export const ACTION_TO_REPORT_POST = "nahl\u00e1senie pr\u00edspevku";
export const ACTION_TO_SEND_HEART = "zaslanie srdie\u010dka";
export const ACTION_TO_TURN_NOTIFICATIONS_ON = "odoberanie upozornen\u00ed na nov\u00e9 odpovede";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_POST = "Naozaj chce\u0161 zmaza\u0165 pr\u00edspevok?";
export const EXPLAIN_POST_DELETION = "Zadaj bli\u017e\u0161ie od\u00f4vodnenie:";
export const FORUM_TURNED_OFF_NOTIFICATIONS_FOR_NEW_ANSWERS = "Vypla si si upozornenia na nov\u00e9 odpovede k tejto diskusii.";
export const FORUM_TURNED_ON_NOTIFICATIONS_FOR_NEW_ANSWERS = "Zapla si si upozornenia na nov\u00e9 odpovede k tejto diskusii.";
